import { AiOutlineCloudUpload } from "react-icons/ai";
import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 94vh;
  background: #fcfcfc;
  padding: 5px 10px 50px 10px;

  ::-webkit-scrollbar {
    width: 4px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    background: #11a7d9;
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }

  ::-webkit-scrollbar-corner {
    background: #11a7d9;
  }
`;

export const Title = styled.h1`
  color: #444444;
  font-family: "Inter";
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 15px;
`;

export const Hr = styled.hr`
  border-radius: 30px;
  background: #11a7d9;
  width: 376px;
  height: 2px;
  margin-bottom: 24px;
  margin-top: -19.5px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  padding-bottom: 50px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: ${(props) => props.justifyContent || "end"};
  align-items: center;
  width: 100%;
  height: 64px;
  gap: 5px;
  padding-right: 20px;
`;

export const BtnActions = styled.div`
  display: flex;
  height: 35px;
  width: 40px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0px 0.751px 1.503px 0px rgba(16, 24, 40, 0.05);
  background: ${({ $isDelete, $disabled }) => {
    if ($isDelete && !$disabled) {
      return "#024";
    }

    if (!$isDelete && !$disabled) {
      return "#11a7d9";
    }

    if ($disabled) {
      return "#C7C9D9";
    }
  }};
`;

export const DocumentCard = styled.div`
  box-shadow: 2px 2px 2px 0px rgba(155, 155, 155, 0.25);
  border-radius: 8px;
  padding: 40px;
  gap: 16px;
  width: 354px;
  height: 160px;
  background: rgba(255, 255, 255, 1);
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

export const ReturnLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin-bottom: 20px;

  p {
    color: #11a7d9;
    font-family: "Open Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-decoration-line: underline;
    margin: 0;
  }
`;
const StatusBadge = styled.div`
  color: white;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-family: "Inter", sans-serif;
  white-space: nowrap;
  width: fit-content;
  min-width: 180px;
  max-width: none;
  margin: 0 auto;
`;

export const ApprovedStatus = styled(StatusBadge)`
  background-color: #33d27e;
`;

export const PendingStatus = styled(StatusBadge)`
  background-color: #efd126;
`;

export const ReprovedStatus = styled(StatusBadge)`
  background-color: #d24633;
`;

export const WaitStatus = styled.div`
  color: #666666;
  font-style: italic;
  font-size: 12px;
  text-align: center;
  display: inline-block;
  font-family: "Inter", sans-serif;
`;

export const BtnUpload = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 16px;
  width: fit-content;
  height: 100%;
  gap: 35px;
  text-decoration: underline;
  color: rgba(0, 34, 68, 1);
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    opacity: 0.8;
    transition: 0.2s;
  }
`;

export const UploadIcon = styled(AiOutlineCloudUpload)`
  color: rgba(0, 34, 68, 1);
  margin-top: -4px;
`;

export const BtnDownload = styled.div`
  display: flex;
  padding: 8px 12px;
  justify-content: end;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  color: #002244;
`;

export const BtnInfo = styled.div`
  display: flex;
  padding: 8px 12px;
  justify-content: end;
  align-items: center;
  border-radius: 10px;
  color: #002244;
`;

export const BtnTrash = styled.button`
  display: flex;
  padding: 8px 12px;
  justify-content: end;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  color: #002244;
  background: transparent;
  border: none;

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
    `}
`;

export const BtnRefresh = styled.button`
  display: flex;
  padding: 8px 12px;
  justify-content: end;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  color: #002244;
  background: transparent;
  border: none;

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
    `}
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px 20px;
  width: 100%;
  min-height: 300px;

  p {
    margin-top: 20px;
    color: #666666;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;
  }
`;

export const LoadingSpinner = styled.img`
  width: 42px;
  height: 42px;
  animation: rotation 2s infinite linear;

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

// Cards de estatísticas
export const StatsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin: 24px 0;
  flex-wrap: wrap;
`;

export const StatsCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  transition: all 0.3s ease;
  flex: 1;

  &:hover {
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

export const StatsIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.approved {
    background: rgba(34, 197, 94, 0.1);
    color: #22c55e;
  }

  &.pending {
    background: rgba(245, 158, 11, 0.1);
    color: #c0780c;
  }

  &.reproved {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
  }
`;

export const StatsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StatsNumber = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1;
`;

export const StatsLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  text-transform: capitalize;
`;

// Componentes para nome do documento com tooltip
export const DocumentNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DocumentNameText = styled.div`
  margin-top: ${(props) => (props.$hasWarning ? "5px" : "0")};
`;

export const DocumentWarningIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpandedInnerTableWrapper = styled.div`
  background: #eaecef;
  width: 100% !important;

  .ant-table,
  .ant-table-container,
  .ant-table-content {
    background: transparent;
  }

  .ant-table-tbody > tr,
  .ant-table-tbody > tr > td,
  .ant-table-tbody > tr.ant-table-row > td,
  .ant-table-tbody > tr.ant-table-expanded-row > td {
    background: transparent !important;
    border-bottom: 1px solid #d4d7db;
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;
  }

  .ant-table-tbody > tr:hover > td,
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: transparent !important;
  }
`;
